var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    fillRule: "evenodd",
    d: "M.228.228a.78.78 0 0 1 1.1 0L7 5.9 12.672.228a.778.778 0 1 1 1.1 1.1L8.1 7l5.672 5.672a.778.778 0 0 1-1.1 1.1L7 8.1l-5.672 5.672a.778.778 0 0 1-1.1-1.1L5.9 7 .228 1.328a.78.78 0 0 1 0-1.1",
    clipRule: "evenodd"
  })));
};
export default SvgClose;